export const download = async (url: string) => {
  const fileName = url.substring(url.lastIndexOf('/') + 1);

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Disposition': `attachment; filename="${fileName}"`,
    },
  });

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', fileName);

  document.body.appendChild(link);

  link.click();

  link?.parentNode?.removeChild(link);
};
